export const PROFESSIONAL = "professional";
export const FREE = "free";

export const FREE_MATCH_LIMIT = 9;
